/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-Auth Admin API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AdminResetPasswordRestDto } from '../models';
import { AuthorizationCodeLoginRestDto } from '../models';
import { BasicLoginRestDto } from '../models';
import { LoginResponseRestDto } from '../models';
import { LogoutRestDto } from '../models';
import { LostPasswordRestDto } from '../models';
import { MfaChallengeRequestRestDto } from '../models';
import { MfaChallengeRestDto } from '../models';
import { MfaVerifyRequestRestDto } from '../models';
import { RedirectResponseRestDto } from '../models';
import { RefreshTokenLoginRestDto } from '../models';
import { SsoLoginRestDto } from '../models';
import { TokenExchangeRequestRestDto } from '../models';
import { TokenExchangeResponseRestDto } from '../models';
/**
 * AdminAuthenticationEndpointsApi - axios parameter creator
 * @export
 */
export const AdminAuthenticationEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.04 Send an OTP for SMS/email (not needed for TOTP)
         * @param {MfaChallengeRequestRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeMfa: async (body: MfaChallengeRequestRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling challengeMfa.');
            }
            const localVarPath = `/admin/v1/login/mfa/challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchanges the identity token of the calling DP user for a restricted identity token of another user group. The caller authenticates with its own identity token in the Authorization header. Only users with cug_code DP may call this endpoint, for every exchange type; any other caller is refused with 403.  Exchange type RESTRICTED_ADMIN issues an identity token with these properties: - `dp:cug.cug_code` = `ADMIN`, granting access to exactly the customer codes given in `customer_codes`. The customer codes are trimmed and not checked for existence; a code that is empty after trimming is refused with 400; duplicate codes are silently removed. - `aud` = exactly these values: `<host>/pharma-cms/_*`, `<host>/pharma-cpc/product_mgmt/_*`, `<host>/pharma-cpc/public/_*`, `<host>/pharma-license/license_info/v1/license/product_feature/authorization`, `<host>/pharma-license/license_info/v1/license/main`, `<host>/pharma-customer/customer/v1/customer`, `<host>/pharma-customer/customer/v1/customer/_*_/settings/domain/main`, `<host>/pharma-content/customer/v1/language`, `<host>/pharma-master/enum/v1/enum/by_classname/_*`, `<host>/pharma-content/customer/v1/color_scheme`. Calls to any other route are refused. - `sub`, `dp:email` and `dp:profile` are copied from the DP token. `dp:user_roles` and the tenant `user_roles` are empty, and the MFA claims (`dp:mfa`) are false. - `act` = `{\"sub\": \"<id of the calling DP user>\", \"dp:cug_code\": \"DP\"}` (RFC 8693 actor claim). - `dp:token_exchange` = `{\"type\": \"RESTRICTED_ADMIN\", \"origin_cug_code\": \"DP\"}`. - Lifetime 3600 seconds (`expires_in`). No refresh token is issued; after expiry the caller exchanges its DP identity token again.  Each exchange is written to the application log (calling user, customer codes, moment).
         * @summary REST.API.AUTH.ADMIN.17 Exchange the identity token of a DP user for a restricted token.
         * @param {TokenExchangeRequestRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeToken: async (body: TokenExchangeRequestRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling exchangeToken.');
            }
            const localVarPath = `/admin/v1/token/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.02 Login admin with email and password.
         * @param {AuthorizationCodeLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokensUsingCode: async (body: AuthorizationCodeLoginRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling getTokensUsingCode.');
            }
            const localVarPath = `/admin/v1/login/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.01 Login admin with email and password.
         * @param {BasicLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithEmailAndPassword: async (body: BasicLoginRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loginWithEmailAndPassword.');
            }
            const localVarPath = `/admin/v1/login/basic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.03 Login admin with refresh token.
         * @param {RefreshTokenLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithRefreshToken: async (body: RefreshTokenLoginRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loginWithRefreshToken.');
            }
            const localVarPath = `/admin/v1/login/refresh_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.15 Login admin with SSO.
         * @param {SsoLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSSO: async (body: SsoLoginRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loginWithSSO.');
            }
            const localVarPath = `/admin/v1/auth/sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.16 Logout admin.
         * @param {LogoutRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (body: LogoutRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling logout.');
            }
            const localVarPath = `/admin/v1/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.06 Request lost password mail.
         * @param {LostPasswordRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lostPassword: async (body: LostPasswordRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling lostPassword.');
            }
            const localVarPath = `/admin/v1/lost_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.07 Reset password.
         * @param {AdminResetPasswordRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (body: AdminResetPasswordRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/admin/v1/reset_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.05 Verify MFA code and issue tokens
         * @param {MfaVerifyRequestRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyMfa: async (body: MfaVerifyRequestRestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling verifyMfa.');
            }
            const localVarPath = `/admin/v1/login/mfa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAuthenticationEndpointsApi - functional programming interface
 * @export
 */
export const AdminAuthenticationEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.04 Send an OTP for SMS/email (not needed for TOTP)
         * @param {MfaChallengeRequestRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeMfa(_axios: AxiosInstance, body: MfaChallengeRequestRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).challengeMfa(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Exchanges the identity token of the calling DP user for a restricted identity token of another user group. The caller authenticates with its own identity token in the Authorization header. Only users with cug_code DP may call this endpoint, for every exchange type; any other caller is refused with 403.  Exchange type RESTRICTED_ADMIN issues an identity token with these properties: - `dp:cug.cug_code` = `ADMIN`, granting access to exactly the customer codes given in `customer_codes`. The customer codes are trimmed and not checked for existence; a code that is empty after trimming is refused with 400; duplicate codes are silently removed. - `aud` = exactly these values: `<host>/pharma-cms/_*`, `<host>/pharma-cpc/product_mgmt/_*`, `<host>/pharma-cpc/public/_*`, `<host>/pharma-license/license_info/v1/license/product_feature/authorization`, `<host>/pharma-license/license_info/v1/license/main`, `<host>/pharma-customer/customer/v1/customer`, `<host>/pharma-customer/customer/v1/customer/_*_/settings/domain/main`, `<host>/pharma-content/customer/v1/language`, `<host>/pharma-master/enum/v1/enum/by_classname/_*`, `<host>/pharma-content/customer/v1/color_scheme`. Calls to any other route are refused. - `sub`, `dp:email` and `dp:profile` are copied from the DP token. `dp:user_roles` and the tenant `user_roles` are empty, and the MFA claims (`dp:mfa`) are false. - `act` = `{\"sub\": \"<id of the calling DP user>\", \"dp:cug_code\": \"DP\"}` (RFC 8693 actor claim). - `dp:token_exchange` = `{\"type\": \"RESTRICTED_ADMIN\", \"origin_cug_code\": \"DP\"}`. - Lifetime 3600 seconds (`expires_in`). No refresh token is issued; after expiry the caller exchanges its DP identity token again.  Each exchange is written to the application log (calling user, customer codes, moment).
         * @summary REST.API.AUTH.ADMIN.17 Exchange the identity token of a DP user for a restricted token.
         * @param {TokenExchangeRequestRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeToken(_axios: AxiosInstance, body: TokenExchangeRequestRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenExchangeResponseRestDto>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).exchangeToken(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.02 Login admin with email and password.
         * @param {AuthorizationCodeLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokensUsingCode(_axios: AxiosInstance, body: AuthorizationCodeLoginRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseRestDto>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).getTokensUsingCode(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.01 Login admin with email and password.
         * @param {BasicLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithEmailAndPassword(_axios: AxiosInstance, body: BasicLoginRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).loginWithEmailAndPassword(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.03 Login admin with refresh token.
         * @param {RefreshTokenLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithRefreshToken(_axios: AxiosInstance, body: RefreshTokenLoginRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseRestDto>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).loginWithRefreshToken(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.15 Login admin with SSO.
         * @param {SsoLoginRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithSSO(_axios: AxiosInstance, body: SsoLoginRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectResponseRestDto>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).loginWithSSO(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.16 Logout admin.
         * @param {LogoutRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(_axios: AxiosInstance, body: LogoutRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectResponseRestDto>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).logout(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.06 Request lost password mail.
         * @param {LostPasswordRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lostPassword(_axios: AxiosInstance, body: LostPasswordRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).lostPassword(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.07 Reset password.
         * @param {AdminResetPasswordRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(_axios: AxiosInstance, body: AdminResetPasswordRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).resetPassword(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.ADMIN.05 Verify MFA code and issue tokens
         * @param {MfaVerifyRequestRestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyMfa(_axios: AxiosInstance, body: MfaVerifyRequestRestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AdminAuthenticationEndpointsApiAxiosParamCreator(configuration).verifyMfa(body, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AdminAuthenticationEndpointsApi - object-oriented interface
 * @export
 * @class AdminAuthenticationEndpointsApi
 * @extends {BaseAPI}
 */
export class AdminAuthenticationEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.AUTH.ADMIN.04 Send an OTP for SMS/email (not needed for TOTP)
     * @param {MfaChallengeRequestRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public challengeMfa(body: MfaChallengeRequestRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).challengeMfa(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchanges the identity token of the calling DP user for a restricted identity token of another user group. The caller authenticates with its own identity token in the Authorization header. Only users with cug_code DP may call this endpoint, for every exchange type; any other caller is refused with 403.  Exchange type RESTRICTED_ADMIN issues an identity token with these properties: - `dp:cug.cug_code` = `ADMIN`, granting access to exactly the customer codes given in `customer_codes`. The customer codes are trimmed and not checked for existence; a code that is empty after trimming is refused with 400; duplicate codes are silently removed. - `aud` = exactly these values: `<host>/pharma-cms/_*`, `<host>/pharma-cpc/product_mgmt/_*`, `<host>/pharma-cpc/public/_*`, `<host>/pharma-license/license_info/v1/license/product_feature/authorization`, `<host>/pharma-license/license_info/v1/license/main`, `<host>/pharma-customer/customer/v1/customer`, `<host>/pharma-customer/customer/v1/customer/_*_/settings/domain/main`, `<host>/pharma-content/customer/v1/language`, `<host>/pharma-master/enum/v1/enum/by_classname/_*`, `<host>/pharma-content/customer/v1/color_scheme`. Calls to any other route are refused. - `sub`, `dp:email` and `dp:profile` are copied from the DP token. `dp:user_roles` and the tenant `user_roles` are empty, and the MFA claims (`dp:mfa`) are false. - `act` = `{\"sub\": \"<id of the calling DP user>\", \"dp:cug_code\": \"DP\"}` (RFC 8693 actor claim). - `dp:token_exchange` = `{\"type\": \"RESTRICTED_ADMIN\", \"origin_cug_code\": \"DP\"}`. - Lifetime 3600 seconds (`expires_in`). No refresh token is issued; after expiry the caller exchanges its DP identity token again.  Each exchange is written to the application log (calling user, customer codes, moment).
     * @summary REST.API.AUTH.ADMIN.17 Exchange the identity token of a DP user for a restricted token.
     * @param {TokenExchangeRequestRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public exchangeToken(body: TokenExchangeRequestRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).exchangeToken(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.02 Login admin with email and password.
     * @param {AuthorizationCodeLoginRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public getTokensUsingCode(body: AuthorizationCodeLoginRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).getTokensUsingCode(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.01 Login admin with email and password.
     * @param {BasicLoginRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public loginWithEmailAndPassword(body: BasicLoginRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).loginWithEmailAndPassword(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.03 Login admin with refresh token.
     * @param {RefreshTokenLoginRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public loginWithRefreshToken(body: RefreshTokenLoginRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).loginWithRefreshToken(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.15 Login admin with SSO.
     * @param {SsoLoginRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public loginWithSSO(body: SsoLoginRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).loginWithSSO(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.16 Logout admin.
     * @param {LogoutRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public logout(body: LogoutRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).logout(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.06 Request lost password mail.
     * @param {LostPasswordRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public lostPassword(body: LostPasswordRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).lostPassword(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.07 Reset password.
     * @param {AdminResetPasswordRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public resetPassword(body: AdminResetPasswordRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).resetPassword(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.ADMIN.05 Verify MFA code and issue tokens
     * @param {MfaVerifyRequestRestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthenticationEndpointsApi
     */
     public verifyMfa(body: MfaVerifyRequestRestDto, options?: any) {
        return AdminAuthenticationEndpointsApiFp(this.configuration).verifyMfa(this.axios, body, options).then((request) => request(this.axios, this.basePath));
    }

}
